<template>
    <div>

        <Card>
            <p slot="title"> Histori Penarikan </p>

            <Row type="flex" justify="space-between">
                <Col span="4">
                <Select style="width: 250px;" placeholder="Ketik Marking" v-model="markingIdSelected" filterable
                    clearable remote :remote-method="getMarkingByCode" :loading="loadingGetMarking"
                    @on-change="updateFilter">
                    <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">{{ option.label
                        }}
                    </Option>
                </Select>
                </Col>
                <Col span="4">
                <Date-picker v-model="createDate" style="width: 180px;" type="daterange" format="yyyy-MM-dd"
                    @on-change="updateFilter" placeholder="Create date">
                </Date-picker>
                </Col>
                <Col span="2">
                <Button type="primary" :loading="isLoadingGetReceivable" icon="ios-search" @click="getReceivableData"
                    v-show="isSearchShow">
                    <span v-if="!isLoadingGetReceivable">Cari</span>
                    <span v-else>Wait.....</span>
                </Button>
                </Col>
                <Col span="1">
                <Spin size="large" v-show="isLoadingGetReceivable"></Spin>
                </Col>
            </Row>

            <br>

            <Table :columns="tableColumns" :data="receivables"></Table>
        </Card>

    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'


var axios = require('axios');
const numeral = require('numeral');

export default {
    data() {
        return {
            markingIdSelected: '',
            createDate: ['', ''],
            receivables: [],
            optionMarkings: [],

            loadingGetMarking: false,
            isLoadingGetReceivable: false,
            isSearchShow: false,
            tableColumns: [
                {
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: 'Marking',
                    key: 'markingHeaderCode',
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Credit Amount',
                    key: 'creditAmount',
                    align: 'left',
                    sortable: false,
                    render: (h, params) => {
                        const creditAmount = params.row.creditAmount

                        return h('span', {}, 'Rp.' + numeral(creditAmount).format('0,0'))
                    }
                },
                {
                    title: 'Files',
                    key: 'withdrawalFilename',
                    render: (h, params) => {
                        const { row } = params

                        return h('div', [
                            h('a', {
                                style: {
                                    textDecoration: 'underline'
                                },
                                on: {
                                    click: () => {
                                        this.downloadFile(row.markingHeaderCode, row.withdrawalFilename)
                                    }
                                }
                            }, row.withdrawalFilename)
                        ]);
                    }
                },
                {
                    title: 'Created Date',
                    key: 'created_at'
                },
                {
                    title: 'Action',
                    align: 'center',
                    render: (h, params) => {
                        const parent = this
                        const receivable = params.row

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: function () {
                                        parent.showPendapatanDeposit(receivable)
                                    }
                                }
                            }, 'Batalkan Penarikan')
                        ])
                    }
                }
            ],
        }
    },

    methods: {
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.subbranchcode
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheadercode,
                                    label: item.markingheadercode
                                };
                            });
                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.loadingGetMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),

        getHistoryWD: function () {

            if (this.markingIdSelected !== '') {
                return HTTP.post('deposit/marking', { markingheadercode: this.markingIdSelected })
            }
        },
        getWDFiles: function () {

            let createDateStart = null
            let createDateEnd = null

            if (this.createDate[0] != '') {
                createDateStart = moment(this.createDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD")
                createDateEnd = moment(this.createDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD")
            }

            const payload = {
                markingheadercode: this.markingIdSelected,
                createdatestart: createDateStart,
                createdateend: createDateEnd
            }

            return HTTP.post('deposit/history-withdrawal/marking', payload)
        },

        getReceivableData: function () {

            this.loadingGetReceivable = true;

            axios.all([
                this.getHistoryWD(),
                this.getWDFiles()
            ]).then(axios.spread((historyList, wdFiles) => {
                console.log({ historyList });
                console.log({ wdFiles });

                this.receivables = wdFiles.data
                this.loadingGetReceivable = false;
            }))
                .catch(e => {
                    this.loadingGetMarking = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        downloadFile: function (markingHeaderCode, fileName) {
            let payload = {
                markingHeaderCode: markingHeaderCode,
                filename: fileName
            }

            console.log({ payload });
            HTTP
                .post('deposit/file/download', payload, { responseType: 'blob' })
                .then(response => {
                    console.log({ response });
                    let a = document.createElement("a");
                    let url = window.URL.createObjectURL(response.data);

                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        updateFilter: function () {
            const markingIdSelected = this.markingIdSelected
            const createDate = this.createDate

            if (markingIdSelected == '' && createDate[0] == '') {
                this.isSearchShow = false
            } else {
                this.isSearchShow = true

            }
        }

    },
    filters: {
        currency: function (value) {
            if (!value) return ''

            return numeral(value).format('0,0')
        }
    }
}

</script>



// WEBPACK FOOTER //
// ReceivableWithdrawalHistory.vue?715073d4